( function ( $ ) {
	// Fixed menu
	const nav = $( '.site-header' );
	if ( nav.length !== 0 ) {
		const navHeight = nav[ 0 ].offsetHeight;
		const navFromTop = nav[ 0 ].offsetTop;

		$( window ).scroll( function () {
			const scrollTop = this.scrollY;
			if (
				scrollTop > navFromTop + navHeight * 2 - 50 &&
				! nav.hasClass( 'fixed-nav' )
			) {
				nav.addClass( 'fixed-nav animated slideindown' );
			} else if (
				scrollTop < navFromTop + navHeight * 2 - 50 &&
				nav.hasClass( 'fixed-nav' )
			) {
				nav.removeClass( 'fixed-nav animated slideindown' );
			}
		} );
	}
	// Fixed menu

	$( '.single-podcast h1.entry-title' ).html( function ( i, html ) {
		return html.replace( /(^\S+)/, '<span class="beige">$1</span>' );
	} );

	if (
		$( '.single-sfwd-topic' ).length !== 0 ||
		$( '.single-sfwd-lessons' ).length !== 0
	) {
		if ( $( '.learndash-wrapper' ).length === 0 ) {
			$( '.site-header' ).addClass( 'no-access' );
		}
	}
} )( jQuery );
